var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("custom-callout", { attrs: { "border-color": _vm.borderColor } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-3 col-lg-2 border-right" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column align-items-center justify-content-center"
          },
          [
            _vm.isActive
              ? _c("span", {
                  staticClass: "badge badges badge-active",
                  domProps: { textContent: _vm._s("Activo") }
                })
              : _c("span", {
                  staticClass: "badge badges badge-inactive",
                  domProps: { textContent: _vm._s("Inactivo") }
                })
          ]
        )
      ]),
      _c("div", { staticClass: "col-5 col-lg-4" }, [
        _c("div", { staticClass: "legend" }, [_vm._v("Nombre del Proveedor:")]),
        _c("div", {
          staticClass: "font-weight-normal text-black",
          domProps: { textContent: _vm._s(_vm.data.name) }
        })
      ]),
      _c("div", { staticClass: "col-4 col-lg-3" }, [
        _c("div", { staticClass: "legend" }, [_vm._v("Tipo de Proveedor:")]),
        _c("div", {
          staticClass: "font-weight-normal text-black",
          domProps: { textContent: _vm._s(_vm.data.typeName) }
        })
      ]),
      _c(
        "div",
        { staticClass: "col-12 col-lg-3 d-flex justify-content-end" },
        [
          _c("action-button", {
            staticClass: "mx-4 px-4",
            attrs: {
              i: "fas fa-file-import",
              text: "Entrar",
              variant: "outline-success"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({
                  name: "provider-edit",
                  params: {
                    companyId: _vm.data.companyId,
                    editMode: false,
                    fiscalYearId: _vm.data.fiscalYearId
                  }
                })
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }